<template>
  <div class="second-layout">
    <v-container
      v-for="(persona, i) in personas"
      :key="i"
      fluid
      class="pa-0 ma-0"
    >
      <highlight-container
        v-if="$store.state.persona.selected.id === persona.id"
        :title="persona.title"
        :subtitle="persona.subtitle"
        alignment="center"
      >
        <v-row>
          <v-col align="center" cols="12">
            <v-alert
              v-if="
                $store.state.persona.selected.id === 0 ||
                $store.state.persona.selected.id === 1 ||
                $store.state.persona.selected.id === 2
              "
              border="left"
              color="orange"
              dense
              icon="mdi-map-marker"
              type="success"
              class="contact-ribbon"
              >EXCLUSIVO PARA <strong>PESSOA JURÍDICA</strong></v-alert
            >
            <!-- Formulário de empreendedores -->
            <div
              v-if="
                $store.state.persona.selected.id === 0 ||
                $store.state.persona.selected.id === 1
              "
              class="form-wrapper"
            >
              <HubspotForm
                form-id="e7bc1ea7-ecf6-4977-8d63-a1225c7d8a35"
                :analytics-data="{
                  eventCategory: 'Formulário',
                  eventAction: 'sent-B2B',
                  eventLabel: 'empreendedores-aba-contato',
                }"
              />
              <div class="form-popup-wrapper">
                <p class="form-text">Por que coletamos esses dados?</p>
                <span class="form-popup-icon">&#9432;</span>
                <div class="form-popup">
                  <div class="form-popup-close"></div>
                  <p class="form-text form-popup-text">
                    <strong>Nome da empresa:</strong> Informação necessária para
                    identificação do negócio (em caso de clientes em
                    potencial).<br />
                    <strong>E-mail / Telefone: </strong>Dados utilizados para
                    que o representante da empresa entre em contato para
                    apresentar a solução.<br />
                    <strong
                      >Sua empresa comercializa produtos em embalagens:</strong
                    >
                    Informação essencial para nós. <br />
                    Nossa solução é focada na compensação de massa de
                    embalagens, logo, se uma empresa não utiliza embalagens em
                    seus produtos, nossa solução passa a não ser adequada.
                  </p>
                </div>
              </div>
            </div>

            <!-- Formulário de Corporações -->
            <HubspotForm
              v-if="$store.state.persona.selected.id === 2"
              form-id="dda10958-6157-4671-9d55-7cfdf67412fd"
              :analytics-data="{
                eventCategory: 'Formulário',
                eventAction: 'sent-B2B',
                eventLabel: 'corporacoes-aba-contato',
              }"
            />
            <associations-contact
              v-if="$store.state.persona.selected.id === 3"
              event-label="associacoes-contato"
            />
            <operators-contact
              v-if="$store.state.persona.selected.id === 4"
              event-label="operadores-contato"
            />

            <!-- Formulário de Consumidores -->
            <HubspotForm
              v-if="$store.state.persona.selected.id === 5"
              form-id="8f8571d9-f76b-48ed-b8c2-7945ad5d8ee4"
              :analytics-data="{
                eventCategory: 'Formulário',
                eventAction: 'sent-B2C',
                eventLabel: 'contato',
              }"
            />
          </v-col>
          <v-col align="center" cols="12">
            <p>Ou envie um e-mail para atendimento@eureciclo.com.br</p>
          </v-col>
        </v-row>
      </highlight-container>
    </v-container>
  </div>
</template>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.contact-ribbon
  display: inline-block
  max-width: 600px
  text-align: left
</style>

<script>
export default {
  name: 'Contact',
  metaInfo: {
    title: 'Contato',
  },
  components: {
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
    HubspotForm: () => import('@/components/HubspotForm.vue'),
    AssociationsContact: () =>
      import('@/components/Forms/AssociationsContact.vue'),
    OperatorsContact: () => import('@/components/Forms/OperatorsContact.vue'),
  },
  data() {
    return {
      personas: [
        {
          title: 'Vamos ajudar a sua empresa a ter o selo eureciclo',
          subtitle:
            'Compense o impacto ambiental de suas embalagens com segurança jurídica e comunique ao seu consumidor a transformação sustentável da sua empresa.',
          id: 0,
        },
        {
          title: 'Vamos ajudar a sua empresa a ter o selo eureciclo',
          subtitle:
            'Compense o impacto ambiental de suas embalagens com segurança jurídica e comunique ao seu consumidor a transformação sustentável da sua empresa.',
          id: 1,
        },
        {
          title: 'Receba o contato de nossos especialistas',
          id: 2,
        },
        {
          title: 'Receba um contato para ser aderente',
          id: 3,
        },
        {
          title: 'Receba um contato para ser um operador parceiro',
          id: 4,
        },
        {
          title: 'Vamos ajudar a sua empresa a ter o selo eureciclo',
          subtitle:
            'Compense o impacto ambiental de suas embalagens com segurança jurídica e comunique ao seu consumidor a transformação sustentável da sua empresa.',
          id: 5,
        },
      ],
    };
  },
  updated() {
    this.$nextTick(() => {
      this.formPopup();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.formPopup();
    });
  },
  methods: {
    formPopup() {
      const popupIcon = document.querySelector('.form-popup-icon');
      const popupCloseBtn = document.querySelector('.form-popup-close');
      const popup = document.querySelector('.form-popup');
      const openPopup = () => {
        if (!popup.classList.contains('popup-open')) {
          popup.classList.add('popup-open');
        }
      };
      const closePopup = () => {
        if (popup.classList.contains('popup-open')) {
          popup.classList.remove('popup-open');
        }
      };
      if (popupIcon) {
        popupIcon.addEventListener('click', openPopup);
        popupIcon.addEventListener('mouseover', openPopup);
        popupCloseBtn.addEventListener('click', closePopup);
      }
    },
  },
};
</script>
<style lang="sass">
.form-wrapper
  min-height: 530px

.form-popup-wrapper
  display: flex
  align-items: center
  justify-content: center
  position: relative
  font-size: 14px
  line-height: 21px

.form-popup
  position: absolute
  bottom: 40px
  background-color: rgb(255, 255, 255)
  max-width: 321px
  border: 1px solid rgb(0, 0, 0)
  padding: 13px
  transition-duration: 200ms
  transition-timing-function: ease
  transition-delay: 0s
  transition-property: all
  opacity: 0
  z-index: -1

.form-popup .form-popup-text
  margin-bottom: 0

.form-popup-icon
  color: rgb(0, 164, 229)
  margin-bottom: 15px
  margin-left: 7px
  cursor: help

.form-popup.popup-open
  opacity: 1
  z-index: 0

.form-popup-close
  position: absolute
  right: 10px
  width: 8px
  height: 8px
  opacity: 0.3
  transition-duration: 200ms
  transition-timing-function: ease
  transition-delay: 0s
  transition-property: all
  cursor: pointer

.form-popup-close:hover
  opacity: 1

.form-popup-close::before, .form-popup-close::after
  position: absolute
  content: ' '
  height: 13px
  width: 4px
  background-color: rgb(51, 51, 51)

.form-popup-close::before
  transform: rotate(45deg)

.form-popup-close::after
  transform: rotate(-45deg)

@media (min-width: 768px)
  .form-popup
    max-width: 500px

.new-color
  .form-popup
    border: 1px solid rgb(0, 48, 54)
</style>
